// exports.onServiceWorkerUpdateReady = () => {
//     const answer = window.confirm(
//         `This application has been updated. ` +
//             `Reload to display the latest version?`
//     );
//     if (answer === true) {
//         window.location.reload();
//     }
// };

export const onServiceWorkerUpdateReady = () => window.location.reload();


//export const onRouteUpdate = ({ location }) => {
 //   // Check if the current path contains a hash fragment (e.g., #section-1)
 //   if (location && location.hash) {
 //       const targetId = location.hash.substring(1); // Remove the '#' symbol
 //       const targetElement = document.getElementById(targetId);
//
 //       if (targetElement) {
            // Scroll to the target section smoothly
//            targetElement.scrollIntoView({ behavior: 'smooth' });
 //       }
//    }
//};

// In gatsby-browser.js
// exports.onRouteUpdate = function ({ location }) {
//     if (typeof window !== 'undefined') {
//         scrollToAnchor(location)
//     }
// }

// /**
//  *
//  * @desc - a function to jump to the correct scroll position
//  * @param {Object} location -
//  * @param {Number} [mainNavHeight] - the height of any persistent nav -> document.querySelector(`nav`)
//  */
// function scrollToAnchor(location, mainNavHeight) {
//     // Check for location so build does not fail
//     if (location && location.hash) {
//         // Use querySelector only if window is available
//         var item = document.querySelector(location.hash)
//         if (item) {
//             window.scrollTo({
//                 top: item.offsetTop - (mainNavHeight || 0),
//                 behavior: "smooth",
//             })
//         }
//     }
// }



// // In gatsby-browser.js
// export const onRouteUpdate = ({ location }) => {
//     if (typeof window !== 'undefined') {
//         scrollToAnchor(location);
//     }
// }

// /**
//  *
//  * @desc - a function to jump to the correct scroll position
//  * @param {Object} location -
//  * @param {Number} [mainNavHeight] - the height of any persistent nav -> document.querySelector(`nav`)
//  */
// function scrollToAnchor(location, mainNavHeight) {
//     // Check for location so build does not fail
//     if (location && location.hash) {
//         // Use querySelector only if window is available
//         var item = document.querySelector(location.hash);
//         if (item) {
//             window.scrollTo({
//                 top: item.offsetTop - (mainNavHeight || 0),
//                 behavior: "smooth",
//             });
//         }
//     }
// }

// export const onServiceWorkerUpdateReady = () => window.location.reload();

// gatsby-browser.js
const ROLLER_SRC = "https://cdn.rollerdigital.com/scripts/widget/checkout_iframe.js";

// 1) Your per-page mapping (edit these)
const CHECKOUT_BY_PATH = {
  "/open-play/": "https://ecom.roller.app/werockthespectrumatlanta/openplay/en-us/home",
  "/upcoming-and-new-events/": "https://ecom.roller.app/werockthespectrumatlanta/events/en-us/home",
  "/themed-events-seasonal-fun/": "https://ecom.roller.app/werockthespectrumatlanta/events/en-us/home",
  "/parents-night-out/": "https://ecom.roller.app/werockthespectrumatlanta/pno/en-us/home",
  "/camp/": "https://ecom.roller.app/werockthespectrumatlanta/camps/en-us/home",
  "/birthday/" : "https://ecom.roller.app/werockthespectrumatlanta/birthdayparties/en-us/home",
  "/memberships/": "https://ecom.roller.app/werockthespectrumatlanta/memberships/en-us/home",
  "/classes/" : "https://ecom.roller.app/werockthespectrumatlanta/classes/en-us/home",
  "/class-schedule/" : "https://ecom.roller.app/werockthespectrumatlanta/classes/en-us/home",
  "/we-rock-care/" : "https://ecom.roller.app/werockthespectrumatlanta/dropoffcare/en-us/home",
  "/hot-deals/" : "https://ecom.roller.app/werockthespectrumatlanta/hotdeals/en-us/home",
};

function normalizePath(p) {
  if (!p) return "/";
  return p.endsWith("/") ? p : `${p}/`;
}

function injectRoller(checkoutUrl) {
  if (!checkoutUrl) return;

  // Remove any existing instance (prevents conflicts)
  const existing = document.getElementById("roller-checkout");
  if (existing) existing.remove();

  // Clear global so script re-inits cleanly
  try {
    delete window.RollerCheckout;
  } catch {
    window.RollerCheckout = undefined;
  }

  const s = document.createElement("script");
  s.id = "roller-checkout";
  s.src = `${ROLLER_SRC}?cb=${Date.now()}`; // cache-bust helps reliability
  s.setAttribute("data-checkout", checkoutUrl);

  document.head.appendChild(s);
}

// Fallback: if someone inserted an inert script in WP content, "activate" it
function activateWpInsertedScriptIfPresent() {
  const inert = document.getElementById("roller-checkout");
  if (!inert) return null;

  const src = inert.getAttribute("src");
  const checkout = inert.getAttribute("data-checkout");

  // Only treat it as a WP-inserted script if it matches the roller src
  if (src && src.includes("checkout_iframe.js") && checkout) {
    return checkout;
  }
  return null;
}

// ROLLER product links (Elfsight widgets, WP content, anywhere) should open in the
// ROLLER flyout rather than a new tab. The widget itself never touches links -- its
// only entry point is RollerCheckout.show() -- so we wire that up here, once,
// document-wide. Capture phase so we run before Elfsight's own click handlers.
function getRollerProductId(url) {
  if (typeof url !== "string" || !url.includes("ecom.roller.app")) return null;
  const match = url.match(/\/product\/(\d+)/i);
  return match ? match[1] : null;
}

function waitForRoller(timeout = 8000) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    (function tick() {
      if (window.RollerCheckout && typeof window.RollerCheckout.show === "function") {
        resolve();
      } else if (Date.now() - start > timeout) {
        reject(new Error("RollerCheckout not ready"));
      } else {
        setTimeout(tick, 50);
      }
    })();
  });
}

function openRollerOverlay(productId) {
  return waitForRoller().then(() => {
    window.RollerCheckout.show({ productId: String(productId) });
  });
}

function handleRollerLinkClick(e) {
  const link = e.target && e.target.closest && e.target.closest('a[href*="ecom.roller.app"]');
  if (!link) return;

  const href = link.getAttribute("href");
  const productId = getRollerProductId(href);
  if (!productId) return;

  // No widget on this page (path not in CHECKOUT_BY_PATH) -- let the link behave normally
  // instead of stalling on waitForRoller.
  if (!document.querySelector("script#roller-checkout")) return;

  // stopImmediatePropagation prevents the widget's own handlers from also firing
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  openRollerOverlay(productId).catch(() => {
    window.location.href = href;
  });
}

export const onClientEntry = () => {
  if (window.__rollerLinkInterceptor) return;
  window.__rollerLinkInterceptor = true;

  document.addEventListener("click", handleRollerLinkClick, true);
  document.addEventListener("auxclick", handleRollerLinkClick, true);

  // Some widgets open tabs via window.open() instead of a real anchor click
  const originalOpen = window.open;
  window.open = function (url, target, features) {
    const productId = getRollerProductId(url);
    if (productId) {
      openRollerOverlay(productId).catch(() => {
        originalOpen.call(window, url, target, features);
      });
      return null;
    }
    return originalOpen.call(window, url, target, features);
  };
};

export const onRouteUpdate = () => {
  const path = normalizePath(window.location.pathname);

  // A) Preferred: use mapping (inject into head per page)
  const mapped = CHECKOUT_BY_PATH[path];
  if (mapped) {
    injectRoller(mapped);
    return;
  }

  // B) Fallback: if WP inserted it on this page, activate it properly
  const wpCheckout = activateWpInsertedScriptIfPresent();
  if (wpCheckout) {
    injectRoller(wpCheckout);
  }
};